import { useMutation } from '@tanstack/react-query';

import {
  type OfferErrorResponse,
  type OfferPriceQuoteResponse,
  type PriceQuoteRequestBody,
} from '../aliases';
import { createCounterOfferPriceQuote } from '../api';

import { type AxiosCompatibleError } from '@/modules/http/types';

type Props = {
  offerId: string;
  onSuccess: (data: OfferPriceQuoteResponse) => void;
  onError?: (error: OfferErrorResponse) => void;
};

export function useCounterOfferPriceQuoteMutation({
  offerId,
  onSuccess,
  onError,
}: Props) {
  return useMutation({
    mutationFn: (body: PriceQuoteRequestBody) =>
      createCounterOfferPriceQuote(offerId, body),
    onSuccess: (data) => {
      onSuccess(data.data);
    },
    onError: async (error: AxiosCompatibleError<OfferErrorResponse>) => {
      const errorData = error?.response?.data;
      if (onError) {
        onError(errorData);
      }
    },
  });
}
